import { BreakpointObserver } from '@angular/cdk/layout';
import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { ExtraExperience } from '@models/profile/extra-experience';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: { year: 'numeric', month: 'numeric' },
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};

@Component({
  selector: 'profile-extra-experience',
  templateUrl: './extra-experience.component.html',
  styleUrls: ['./extra-experience.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExtraExperienceComponent {
  @Input() loading: boolean;
  @Input() model: ExtraExperience;

  readingCommandsAlignment$: Observable<'top' | 'middle'>;

  constructor(
    private readonly breakpointObserver: BreakpointObserver,
    @Inject(PLATFORM_ID) readonly platformId: Record<string, unknown>
  ) {
    if (isPlatformBrowser(platformId)) {
      this.readingCommandsAlignment$ = this.breakpointObserver
        .observe('(min-width: 75em)') // = `xl` breakpoint
        .pipe(
          map((result) => result.matches),
          map((matches) => (matches ? 'top' : 'middle'))
        );
    }
  }
}
